<template>
  <el-drawer :visible.sync="visible" v-bind="$attrs" :show-close="false" v-if="visible" :before-close="handleClose" class="ybl-drawer">
    <div slot="title" class="title">
      <div>{{title}}</div>
      <div class="close" @click="handleClose">
        <i class="iconfont icon-guanbichouti"></i>
      </div>
    </div>
    <slot></slot>
    <div v-if="showFooter" class="footer">
      <el-button plain size="mini" @click="handleClose">取消</el-button>
      <el-button type="primary" size="mini" @click="confirm">保存</el-button>
    </div>
  </el-drawer>
</template>
<script>
export default {
  name: 'YblDrawer',
  props: {
    visible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    title: {
      type: String,
      default: function () {
        return '系统提示'
      }
    },
    showFooter: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="less" scoped>
@import url("../assets/less/color.less");
.ybl-drawer {
  /deep/.el-drawer {
    background-color: @primary-border-color;
    overflow: visible;
  }
  /deep/.el-drawer__header {
    padding: 0;
    margin: 0;
    background-color: #fff;
    margin-bottom: 6px;
  }
  /deep/.el-drawer__body {
    background-color: #fff;
    position: relative;
    padding: 24px;
    padding-bottom: 0px;
  }
}
.title {
  height: 64px;
  font-size: 16px;
  color: @routine-color;
  font-family: Microsoft YaHei;
  line-height: 60px;
  padding: 0 24px;
  font-weight: 600;
  position: relative;
  .close {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0;
    left: -52px;
    background-color: #fff;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      font-size: 20px;
      cursor: pointer;
      color: #8c939d;
    }
  }
}
.footer {
  position: sticky;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: #fff;
  height: 52px;
  z-index: 11;
  box-shadow: 0px 1px 1px 0px rgba(250, 250, 250, 0.97),
    0px -1px 1px 0px #fafafa;
  border-radius: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/Drawer.vue